import { tss } from 'tss-react/mui';

export const useStyles = tss.create(({ theme }) => ({
  dialog: {
    '& .MuiDialog-container': {
      '& .MuiPaper-root': {
        width: '450px',
        maxHeight: '1000px',
        overflowY: 'unset',
      },
    },
  },
  dialogTitle: {
    textAlign: 'center',
    padding: '30px 30px 20px 30px',
  },
  customizedButton: {
    position: 'absolute',
    right: '15px',
    top: '15px',
    padding: 0,
  },
  dialogContent: {
    padding: '0px 30px 30px 30px',
    overflowY: 'hidden',
    height: '500px',
  },
  chatBox: {
    width: '100%',
  },
  toolCallRow: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  chatBoxMessages: {
    padding: '20px',
    width: '100%',
    height: '385px',
    overflow: 'scroll',
    backgroundColor: theme.palette.surface.sunken,
  },
  dialogGridContent: {
    display: 'flex',
    height: '100%',
    justifyContent: 'space-between',
    alignContent: 'space-between',
  },
}));
